import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box
} from '@chakra-ui/react';
import { MailingListType } from '../Table/MaintenanceMailingListTable';

interface props {
  isOpen: boolean;
  onClose: () => void;
  BrowseData: MailingListType | undefined;
}
export const MailingListBrowseWindow: React.FC<props> = (props) => {
  const { isOpen, onClose, BrowseData } = props;
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='340px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            メーリングリストの詳細
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>ID</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.id}
              </Text>

              <Text mt={4}>メールアドレス</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.email}
              </Text>

              <Text mt={4}>有効</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.enable === true ? 'Yes' : 'No'}
              </Text>
              <Text mt={4}>登録日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.created_at}
              </Text>

              <Text mt={4}>更新日時</Text>
              <Text mt={4} w='100%'>
                {BrowseData?.updated_at}
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
